import { createSelector, createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
const INTIAL = {
  products: [],
  totalQuantity: 0,
  totalPrice: 0,
};
const slice = createSlice({
  initialState: INTIAL,
  name: "Cart",
  reducers: {
    addItem: (state, action) => {
      const isContain = state.products.some(
        (item) => item.id == action.payload.id
      );
      if (!isContain) {
        state.products.push({
          ...action.payload,
          subtotal: action.payload.price * action.payload.count,
          quantity: action.payload.count,
        });
      } else if (isContain) {
        const existingItem = state.products.find(
          (item) => item.id === action.payload.id
        );
        existingItem.subtotal += action.payload.price * action.payload.count;
        existingItem.quantity += action.payload.count;
      }
      state.totalPrice += action.payload.price * action.payload.count;
      state.totalQuantity += action.payload.count;
    },
    removeItem: (state, action) => {
      const existingItem = state.products.find(
        (item) => item.id === action.payload.id
      );
      if (existingItem.quantity > 1) {
        console.log(action.payload.price, action.payload.count);
        existingItem.quantity -= action.payload.count;
        existingItem.subtotal -= action.payload.price * action.payload.count;
      }
      state.totalQuantity -= action.payload.count;
      state.totalPrice -= action.payload.count * action.payload.price;
    },
    removeSubtotal: (state, action) => {
      if (action.payload.id) {
        const filteredItems = state.products.filter(
          (item) => item.id !== action.payload.id
        );
        state.products = filteredItems;
        state.totalQuantity -= action.payload.count;
        state.totalPrice -= action.payload.count * action.payload.price;
      }
    },
    removeAll: (state) => {
      state.products = [];
      state.totalQuantity = 0;
      state.totalPrice = 0;
    },
  },
});

export const cartSelector = createSelector(
  (state) => state,
  (state) => state.Cart
);
export default slice.reducer;
export const { addItem, removeItem, removeSubtotal, removeAll } = slice.actions;
